export const validateSignupForm = (data) => {
  const errors = {};

  // --- Required fields ---
  if (!data.first_name.trim()) errors.first_name = "Le prénom est requis.";
  if (!data.last_name.trim()) errors.last_name = "Le nom est requis.";
  if (!data.email.trim()) errors.email = "L'email est requis.";
  if (!data.password.trim()) errors.password = "Le mot de passe est requis.";
  if (!data.confirm_password.trim())
    errors.confirm_password = "Veuillez confirmer votre mot de passe.";
  if (!data.gender) errors.gender = "Veuillez sélectionner un sexe.";
  if (!data.profession.trim()) errors.profession = "La profession est requise.";
  if (!data.professional_address.trim())
    errors.professional_address = "L’adresse professionnelle est requise.";

  // --- First name & last name: only letters (no numbers or special chars) ---
  const nameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]+$/; 
  if (data.first_name && !nameRegex.test(data.first_name)) {
    errors.first_name = "Le prénom ne doit contenir que des lettres.";
  }
  if (data.last_name && !nameRegex.test(data.last_name)) {
    errors.last_name = "Le nom ne doit contenir que des lettres.";
  }

  // --- Date of birth ---
  if (!data.date_of_birth) {
    errors.date_of_birth = "La date de naissance est requise.";
  } else {
    const today = new Date();
    const selectedDate = new Date(data.date_of_birth);

    // Future date check
    if (selectedDate > today) {
      errors.date_of_birth =
        "La date de naissance ne peut pas être dans le futur.";
    }
    // Age restriction (must be 20+)
    else {
      const ageInYears = Math.floor(
        (today - selectedDate) / (1000 * 60 * 60 * 24 * 365)
      );
      if (ageInYears < 20) {
        errors.date_of_birth =
          "Vous devez avoir au moins 20 ans pour vous inscrire.";
      }
    }
  }

  // --- Email format ---
  if (data.email && !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(data.email)) {
    errors.email = "Email invalide.";
  }

  // --- Phone: exactly 8 digits ---
  if (data.phone && !/^\d{8}$/.test(data.phone)) {
    errors.phone = "Le numéro doit contenir exactement 8 chiffres.";
  }

  // --- Password rules ---
  if (data.password && data.password.length < 8) {
    errors.password = "Le mot de passe doit contenir au moins 8 caractères.";
  } else if (data.password && !/\d/.test(data.password)) {
    errors.password = "Le mot de passe doit contenir au moins un chiffre.";
  }

  // --- Password confirmation ---
  if (data.password !== data.confirm_password) {
    errors.confirm_password = "Les mots de passe ne correspondent pas.";
  }

  // --- Gender normalization ---
  if (data.gender && !["homme", "femme"].includes(data.gender.toLowerCase())) {
    errors.gender = "Le genre doit être 'homme' ou 'femme'.";
  }

  return errors;
};
